exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2E9BdC-TyENulLnJvwneI1{text-align:center;margin:0 30px 100px 30px}._2E9BdC-TyENulLnJvwneI1 .eKQaiRPM9DZO102SNJBAA{width:150px;height:150px;margin:30px 0;border-radius:50%}._2E9BdC-TyENulLnJvwneI1 ._3egDZzpKh42FJX3iXss2Eh{display:block;margin:45px 0 0 0}\n", ""]);

// Exports
exports.locals = {
	"S2DMobileView": "_2E9BdC-TyENulLnJvwneI1",
	"routePreview": "eKQaiRPM9DZO102SNJBAA",
	"hasApp": "_3egDZzpKh42FJX3iXss2Eh"
};